import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import { ArrowTrendingUpIcon } from '@heroicons/react/24/outline'
import theme from 'theme'

const Wrapper = styled(Box)`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.large}px;
  pointer-events: none;

  .icon-ring {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing.xLarge}px;
    border: 3px dashed ${theme.colors.menuItemText};
    border-radius: 100px;

    svg {
      width: 36px;
      height: 36px;
      color: ${theme.colors.devicesSecondaryText};
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.md}px;
    text-align: center;
  }

  .title {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xxxLarge};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: normal;
  }

  .description {
    max-width: 490px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 24px;
  }
`

interface Props {
  title: string
  description: string
}

const NoTrendData: FC<Props> = ({ title, description }) => (
  <Wrapper className="no-trend-data" role="status">
    <Box className="icon-ring">
      <ArrowTrendingUpIcon />
    </Box>
    <Box className="text">
      <Typography className="title">{title}</Typography>
      <Typography className="description">{description}</Typography>
    </Box>
  </Wrapper>
)

export default NoTrendData
